import React, { useState } from 'react'

import { GetProducts } from '@web/walter-lib/api'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'
import { Card, CardModal } from '../components/Card'
import { CardsViews } from '../types'
import Form from './Form'
import s from './s.module.css'
import { lang } from './lang'
import CardImage from '~pages/CardsPage/components/CardImage'

interface Props {
    setView: (newView: CardsViews) => void
    product?: GetProducts
}

function NewCard({ product, setView }: Props) {
    const [cardModal, setCardModal] = useState(false)

    return (
        <>
            <CardModal
                data={product}
                showOffer={false}
                onClose={() => setCardModal(false)}
                isOpen={cardModal}
                type="secondary"
            />

            <div className={s.wrap}>
                <div className={s.content}>
                    {product && (
                        <>
                            <div className={s.topDesktop}>
                                <Card data={product} type="secondary" showOffer={false} shortTexts lineClampCount={5} />
                            </div>
                            <div className={s.topMobile}>
                                <CardImage
                                    designId={product?.design?.id}
                                    currency={product?.currency}
                                    cardType={product?.card_type}
                                    className={s.mobileImg}
                                />
                                <div onClick={() => setCardModal(true)}>
                                    <FormattedHTMLMessage {...lang.show} className={s.details} />
                                </div>
                            </div>
                        </>
                    )}
                    {product && <Form setView={setView} data={product} />}
                </div>
            </div>
        </>
    )
}

export default NewCard
